/**
* Data model that represents an appointment (FlexAppointment)
*
* @class AppointmentModel
*/
var AppointmentModel = function (data) {
  var self;	// Convenience reference so the context of 'this' becomes clearer

  // Predicate this data model on the AbstractDataModel.
  // This establishes core functionality required of DataModels,
  // which can be overwritten by methods below.
  // Specifically, conversion of XML data to JSON
  AbstractDataModel.apply(this, arguments);

  self = this;

  self.isShallow = ko.observable();

  // Observable variables represented by this data model
  self.confirmationCode = null;
  self.customProps = [];
  self.customPropsFirst = null;
  /**
   * @type {Array<{name|value}>}
   */
  self.rawCustomProps = [];
  self.description = '';
  self.duration = null;	// Service duration in minutes
  self.email = null;
  self.id = null;
  self.firstName = null;
  self.languagePref = null;
  self.languageName = null;
  self.lastName = null;
  self.locationId = null;
  self.locationName = null;
  self.merchantConsumerInfo = null;
  self.name = null;
  self.needsReminder = null;
  self.notes = null;
  self.partySize = null;
  self.phone = null;
  self.phoneDigitCount = ko.observable(null);
  self.queue = null;
  self.queueId = null;
  self.queueName = ko.observable(null);
  self.recurrence = null;
  self.reminderInterval = null;
  self.resourceIds = [];
  self.resourceName = null;
  self.scheduled = null;
  self.serviceType = null;
  self.sessionId = null;
  self.settingManualStatus = false;
  self.start = null;
  self.statusOld = null;
  self.status = ko.observable(null);
  self.timeblockEnd = null;
  self.transactionType = ko.observable(null);
  self.usePartySize = false;


  self.m = ko.observable(new moment());


	/**
	* Returns a debug string describing the AppointmentModel
	*
	* @method buildDescription
	* @return {String}
	*/
  self.buildDescription = function () {
    var sReturn = '';

    sReturn += 'FlexAppointment ' + self.status() + ' for ' + self.name;
    sReturn += ' - ' + self.m().format('llll');
    sReturn += ', belonging to queue ' + self.queueId;

    return sReturn;
  };


	/**
	* Builds a fully realized date for display in the appointment detail
	*
	* @method getDisplayTime
	* @return {String} Full date string
	*/
  self.getDisplayTime = function () {
    return self.m().format('lll');
  };


	/**
	* Returns the consumer's phone number, masked to only show phone.length characters
	*
	* @method phoneDisplay
	* @return {String} Phone number, masked with ###
	*/
  self.phoneDisplay = function () {
    var position = 0,
      digit = null,
      phone = String(self.phone),
      showLen = self.phoneDigitCount() || 4,
      hiddenNumber = null,
      visNumber = null;

    if (phone != null) {
      while (position <= showLen) {
        digit = phone.substr(phone.length - (position * 1), 1);

        if (isNaN(digit)) {
          ++showLen;
        }

        position++;
      }

      hiddenNumber = phone.substring(0, phone.length - showLen).replace(/[0-9]/g, '#');
      visNumber = phone.substring(phone.length - showLen);

      return hiddenNumber + '' + visNumber;
    }

    return phone;
  };


  self.statusLabel = ko.deferredComputed(function () {
    var statuses = qcal.appointmentStatusObjs();
    var status = self.status();
    var stat = statuses.filter(function (o) {
      return o.val === status;
    });

    if (stat.length > 0) {
      return stat[0].name;
    }
    return (status) ? qcal.messagesWS.get('appointment.status.' + status.toLowerCase()).replace(/_/g, ' ') : '';
  });


	/**
	* Returns the timestring of the start time of the appointment
	*
	* @method timeblockStart
	* @return {String} hhmm of the start of the appointment
	*/
  self.timeblockStart = function () {
    var str = self.m().format('H');

    if (self.m().minutes() > 0) {
      str += self.m().format('mm');
    }

    return str;
  };


	/**
	* Watches for events against the status, before they occur
	*
	* @method status.subscribe.before
	* @return none
	*/
  self.status.subscribe(function (oldVal) {
    self.statusOld = oldVal;
  }, null, 'beforeChange');


	/**
	* Watches for events against the status, as they occur
	*
	* @method status.subscribe.change
	* @return none
	*/
  self.status.subscribe(function (newVal) {
    var tmp = null;

    if (newVal) {
      if (newVal.toUpperCase() == 'REJECTED') {
        if (self.statusOld != null &&
          ($('.appointment-detail').css('top') != '-2000px' ||
            (
              qcal.globalViewType() == 'searchResults' &&
              $('.reject-appointment').css('top') == '-2000px'
            )
          ) &&
          !self.settingManualStatus == true
        ) {
          qcal.confirmPopupDelete(self);
          tmp = self.statusOld;
          self.statusOld = null;
          self.status(tmp);
        }
      }
      else if (newVal != self.statusOld && self.statusOld != null) {
        qcal.updateAppointmentStatusWS.update(self.id, newVal);
      }

      self.settingManualStatus = false;
    }
  }, null, 'change');


	/**
	* Builds a concatenated string of CSS classes to apply to the AppointmentModel in the UI
	*
  * @method appointmentCSS
  * @param {KnockoutObservable} selectedServices the Services currently selected by the Employee
  * @param {KnockoutObservable} selectedResources the Resources currently selected by the Employee
  * @param {servicesWS} the Services/Transaction Types Collection/Store/Web Service
	* @return {String}
	*/
  self.appointmentCSS = function (selectedServices, selectedResources, servicesWS) {
    var cssClasses = [];

    // This class allows the appointment interface to be positioned relatively in
    // day or week views

    // This class allows the appointment to appear relative in size to the scale
    // of the day or week interface
    cssClasses.push('appt-duration-' + self.duration);

    var availableAppointmentStatuses = ['pending',
                                        'approved',
                                        'served_early',
                                        'queued',
                                        'checked_in',
                                        'failed'];

    // If the appointment status in not in the above list of available appointment statuses,
    // hide the appointment from the default view
    if (availableAppointmentStatuses.indexOf(self.status().toLowerCase()) < 0) {
      cssClasses.push('appt-unavailable');
    }

    if (self.transactionType != null) {
      var idx = servicesWS.getServiceIndex(self.transactionType.id);

      // This class colorizes the service based on the generated or custom CSS style
      cssClasses.push('service-type-' + self.transactionType.id);

      // This class colorizes the service based on the generated or custom CSS style
      cssClasses.push('common-service-border-' + (idx + 1));
    }

    var selectedResources = selectedResources();
    var isSelectedResource = function (resourceId) {
      return selectedResources.indexOf(resourceId.toString()) > -1
    }
    var isVisibleForResourceSelection = self.resourceIds.some(isSelectedResource)

    var isSelectedService = function (serviceId) {
      return (self.transactionType && (serviceId.toString() === self.transactionType.id.toString()))
    }
    var isVisibleForServiceSelection = selectedServices().some(isSelectedService)

    // Employee can filter visible Appointments by Resource and/or Service (Transaction Type)
    if (!isVisibleForResourceSelection || !isVisibleForServiceSelection) {
      cssClasses.push('is-hidden');
    }

    return cssClasses.join(' ');
  };



	/**
	 * Returns string indicating the start and end times of the appointment
	 *
	 * @method appointmentStartToEndDisplay
	 * @return {String} Start and end times expressed as a string
	 */
  self.appointmentStartToEndDisplay = function () {
    var start = self.m(),
      end = new moment(start);

    end.add(self.duration, 'minutes');

    return start.format('LT') + '-' + end.format('LT');
  };


	/**
	 * Reads custom properties value on the AppointmentModel by key
	 *
	 * @method getCustomPropByName
	 * @param {String} sName Key of the property to look up
	 * @return {String}
	 */
  self.getCustomPropByName = function (sName) {
    var i = 0;

    if (self.customPropsFirst && self.customPropsFirst.name == sName) {
      return self.customPropsFirst.value;
    }
    else if (self.customProps) {
      for (i = 0; i < self.customProps.length; i++) {
        if (self.customProps[i].name == sName) {
          return self.customProps[i].value;
        }
      }
    }

    return null;
  };


	/**
	 * Method to convert the JSON data representing this DataModel
	 * into observed variables above.
	 *
	 * @method loadData
	 * @param {JSON} data
	 * @return {AppointmentModel}
	 */
  self.loadData = function (data) {
    var serviceDuration = null;

    // TODO: Sometimes the model is passed XML, sometimes it is passed JSON.
    // Previously, it was always passed JSON, and always attempted to convert
    // the JSON to JSON because it actually expected XML.
    if ($.isXMLDoc(data)) {
      AbstractDataModel.prototype.loadData.call(self, data)
    } else {
      self.json = data
    }

    self.confirmationCode = self.json.confirmationCode;

    // Extract readily available top-level attributes
    self.id = self.json.id;
    self.sessionId = self.json.sessionId;
    self.notes = self.json.notes;
    self.queueId = self.json.queueId;
    self.scheduled = self.json.scheduled;		// UTC String
    self.start = self.json.start;
    self.status(self.json.status);


    // Service duration
    // Start by extracting the service duration value
    serviceDuration = self.json.serviceDuration.duration;

    // If the units are hours, convert the duration to minutes
    if (self.json.serviceDuration.units == 'hrs') {
      serviceDuration *= 60;
    }

    // Set the duration now as minutes
    self.duration = serviceDuration;

    // If there is a customer > consumer node, mine it for additional attributes
    if (self.json.customer != null && self.json.customer.consumer != null) {

      // If there is a consumer phone, extract it
      if (self.json.customer.consumer.phone && self.json.customer.consumer.phone.text) {
        self.phone = String(self.json.customer.consumer.phone.text);
      }

      // First name / last name
      self.firstName = self.json.customer.consumer.firstName;
      self.lastName = self.json.customer.consumer.lastName;

      // Create a full customer name for display purposes
      if (self.firstName != null && self.lastName != null) {
        self.name = self.firstName + ' ' + self.lastName;
      }
      else if (self.firstName != null) {
        self.name = self.firstName;
      }
      else if (self.lastName != null) {
        self.name = self.lastName;
      }
      else {
        self.name = 'No name';
      }

      // Extract the email and language preferences
      self.email = self.json.customer.consumer.email
      self.languagePref = self.json.customer.consumer.languagePreference;

    }
    // If there is no customer, snow no name
    // TODO: Make this into a Message bundle call
    else {
      self.name = 'No name';
    }

    // Create a new moment to represent the date
    self.m(new moment(self.json.start));

    var resources = (self.json.resourceSet && self.json.resourceSet.neededResource) ? self.json.resourceSet.neededResource : null;
    if (resources) {
      resources = (Array.isArray(resources)) ? resources : [resources];

      var resourceIds = []
      var resourceNames = resources.reduce(function (resourceDescriptions, resource) {
        // Because XMLToJSON library/helper forced attributes to be Numbers if they parsed as Numbers.
        // See xmlToJson.js Line 178
        resourceIds.push(Number(resource.id));
        resourceDescriptions.push(resource.description);
        return resourceDescriptions;
      }, []);

      self.resourceName = resourceNames.join(', ');
      self.resourceIds = resourceIds;
    }

    if (resources && resources.length > 0) {
      self.locationId = resources[0].locationId;
    }
    else {
      loc = qcal.locationsWS.getLocationByQueueId(self.queueId);
      self.locationId = loc.id;
    }

    if (self.json.transactionType) {
      self.transactionType = ({
        'id': parseInt(self.json.transactionType.id),
        'description': self.json.transactionType.description
      });
    }

    // Load any custom props returned for the customer
    var cProps = (self.json.customer && self.json.customer.customProp) ? self.json.customer.customProp : null;


    if (cProps) {
      cProps = (Array.isArray(cProps)) ? cProps : [cProps];

      // This is necessary because the remaining implementation to populate the 
      // `customProps` property munges the data for UI concerns.
      //
      // This is simpler than writing code to check for email and 
      // subsequently rejoining the props.
      self.rawCustomProps = cProps;

      self.customProps = [];
      
      cProps.forEach(function (prop, idx) {

        // If this is the first property found, set it in this
        // special property. Because the interface has a 'hanging'
        // field (email), this initial property will be displayed
        // side-by-side with the email, if it is not null.
        if (idx == 0) {
          self.customPropsFirst = prop;
        }

        // The customProps will be filled with values to be presented
        // in the appointment detail interface. If email is not null,
        // then the first custom prop will be paired with the email
        // in that same row for display. to make things easier for
        // data binding, we can ignore that in the inclusion to the
        // customProps array, so that we only need to iterate over
        // anything other than the first.
        // If email is blank, then we will include the first property
        // in the collection.
        if ((idx == 0 && self.email == null) || idx > 0) {
          self.customProps.push(prop);
        }
      });
    }

    self.description = self.buildDescription();

    // Return self (AppointmentModel) to be chainable, for best practice
    return self;
  };

  /**
	 * Allow to begin service if appointment is not future appointment
	 *
	 * @method allowBeginService
	 * @param {Moment} today
	 * @return none
	 */
  self.allowBeginService = function(today) {
    return today.isSameOrAfter(self.m().format('YYYY-MM-DD'));
  }

	/**
	 * Allows for the appointment start times to be time zone shifted
	 *
	 * @method updateTZ
	 * @param {String} sTZ
	 * @return none
	 */
  self.updateTZ = function (sTZ) {
    self.m().tz(sTZ);

    self.m.valueHasMutated();
  };


  // If the model was initialized with a data parameter,
  // call the loadData method to populate the observed variables.
  if (data) {
    self.loadData(data);
  }

  // Return self (AppointmentModel) to be chainable, for best practice
  return self;
};

AppointmentModel.prototype = AbstractDataModel.prototype;
AppointmentModel.prototype.constructor = AppointmentModel;


AppointmentModel.prototype.createFromAppointmentHeader = function(appointmentData) {
  var serviceDuration = appointmentData.serviceDuration;
  var consumer = appointmentData.consumer;
  var appointment = new AppointmentModel({
    id: appointmentData.id,
    locationId: appointmentData.locationId,
    queueId: appointmentData.queueId,
    transactionType: {
      description: '',
      id: appointmentData.transactionType
    },
    resourceSet: {
      neededResource: [
        {
          id: appointmentData.resourceId,
          description: "",
          locationId: appointmentData.locationId
        }
      ]
    },
    status: appointmentData.status,
    start: appointmentData.startDateTime,
    serviceDuration: {
      units: serviceDuration.units,
      duration: serviceDuration.duration
    },
    customer: {
      consumer: {
        phone: { text: consumer.phone  },
        firstName: consumer.firstName || null,
        lastName: consumer.lastName || null,
        email: "",
        languagePref: ""
      }
    }
  });

  appointment.isShallow(true);
  return appointment;
}

AppointmentModel.prototype.attr = function () {
  return {
    'id': 'appointment-' + this.id,
    'data-start': this.timeblockStart(),
    'data-duration': this.duration
  }
}

AppointmentModel.prototype.usesResource = function (resourceId) {
  return this.resourceIds.indexOf(resourceId) > -1
}

AppointmentModel.prototype.loadDetailsAndLanguageName = function (data, messages) {
  this.loadData(data);
  if (data.languagePref) {
    this.languageName = messages.languageName(data.languagePref);
  }
  this.isShallow(false)
}


if (typeof exports !== "undefined") {
  exports.AppointmentModel = AppointmentModel;
}
